// src/components/InstallPrompt.js
import React, { useState, useEffect } from 'react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Check if user hasn't dismissed the prompt before
      const dismissed = localStorage.getItem('installPromptDismissed');
      if (!dismissed) {
        setShowPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }
    
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('installPromptDismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#1a3327',
      padding: '16px 24px',
      borderRadius: '12px',
      border: '2px solid #4ade80',
      boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      zIndex: 9999,
      maxWidth: '90vw'
    }}>
      <span style={{ fontSize: '32px' }}>📱</span>
      <div>
        <div style={{ color: '#4ade80', fontWeight: 'bold', marginBottom: '4px' }}>
          Install AgroConnect
        </div>
        <div style={{ color: '#888', fontSize: '13px' }}>
          Add to home screen for offline access
        </div>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={handleInstall}
          style={{
            padding: '8px 16px',
            background: '#4ade80',
            color: '#0f2419',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Install
        </button>
        <button
          onClick={handleDismiss}
          style={{
            padding: '8px 16px',
            background: 'transparent',
            color: '#888',
            border: '1px solid #2d5a45',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Not now
        </button>
      </div>
    </div>
  );
}